import { render, staticRenderFns } from "./SifcopDetailView.vue?vue&type=template&id=66c6e08e&scoped=true"
import script from "./SifcopDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./SifcopDetailView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SifcopDetailView.vue?vue&type=style&index=0&id=66c6e08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c6e08e",
  null
  
)

export default component.exports